/* tslint:disable */
/* eslint-disable */
/**
 * Walnut Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 4.155.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SettingsSchemaAxeDevtoolsProAutoContrastFromJSON, SettingsSchemaAxeDevtoolsProAutoContrastToJSON, } from './SettingsSchemaAxeDevtoolsProAutoContrast';
import { SettingsSchemaGeneralMlFromJSON, SettingsSchemaGeneralMlToJSON, } from './SettingsSchemaGeneralMl';
/**
 * Check if a given object implements the SettingsSchemaAxeDevtoolsPro interface.
 */
export function instanceOfSettingsSchemaAxeDevtoolsPro(value) {
    let isInstance = true;
    isInstance = isInstance && "autoContrast" in value;
    isInstance = isInstance && "igt" in value;
    isInstance = isInstance && "savedTestCollaboration" in value;
    return isInstance;
}
export function SettingsSchemaAxeDevtoolsProFromJSON(json) {
    return SettingsSchemaAxeDevtoolsProFromJSONTyped(json, false);
}
export function SettingsSchemaAxeDevtoolsProFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'autoContrast': SettingsSchemaAxeDevtoolsProAutoContrastFromJSON(json['autoContrast']),
        'igt': SettingsSchemaGeneralMlFromJSON(json['igt']),
        'savedTestCollaboration': SettingsSchemaGeneralMlFromJSON(json['savedTestCollaboration']),
    };
}
export function SettingsSchemaAxeDevtoolsProToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'autoContrast': SettingsSchemaAxeDevtoolsProAutoContrastToJSON(value.autoContrast),
        'igt': SettingsSchemaGeneralMlToJSON(value.igt),
        'savedTestCollaboration': SettingsSchemaGeneralMlToJSON(value.savedTestCollaboration),
    };
}
